import { render, staticRenderFns } from "./RedirectsList.vue?vue&type=template&id=85a7384a&"
import script from "./RedirectsList.vue?vue&type=script&lang=js&"
export * from "./RedirectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports